import EfNav, { EfNavItemProps } from '@elem/ui/ef-nav';
import { useEffect } from 'react';
import { useProductStore } from '@elem/compPage/CES2025/ProductProvider';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

const CESNav = () => {
    const { t } = useLang('ces2025');
    const { pageStatus } = useProductStore();

    const list: EfNavItemProps[] =
        pageStatus === 'statusA'
            ? [
                  {
                      key: 'countdown',
                      title: t('Tab_1'),
                      href: '#CES-2025-B',
                  },
                  {
                      key: 'signUp',
                      title: t('Tab_2'),
                      href: '#CES-2025-C',
                  },
                  {
                      key: 'solutions',
                      title: t('Tab_3'),
                      href: '#CES-2025-D',
                  },
                  {
                      key: 'aboutEcoFlow',
                      title: t('Tab_4'),
                      href: '#CES-2025-E',
                  },
              ]
            : pageStatus === 'statusB'
            ? [
                  {
                      key: 'map',
                      title: t('Tab_5'),
                      href: '#CES-2025-D',
                  },
                  {
                      key: 'signUp',
                      title: t('Tab_2'),
                      href: '#CES-2025-C',
                  },
                  {
                      key: 'solutions',
                      title: t('Tab_6'),
                      href: '#CES-2025-F',
                  },
                  {
                      key: 'limiteDeals',
                      title: t('Tab_7'),
                      href: '#CES-2025-G',
                  },
                  {
                      key: 'aboutEcoFlow',
                      title: t('Tab_4'),
                      href: '#CES-2025-E',
                  },
              ]
            : [];

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const timer = setInterval(() => {
                const header = document.querySelector('.ecoflow-frame-header') as HTMLElement;
                const nav = document.querySelector('.CES-Page .ces-nav') as HTMLElement;
                if (header && nav) {
                    nav.style.top = `${header.offsetHeight}px`;
                    clearInterval(timer);
                }
            }, 500);
            return () => clearInterval(timer);
        }
    }, []);

    return <EfNav className={`ces-nav ${styles.CESNav}`} list={list} isAutoScroll />;
};

export default CESNav;
